/**
 * Pre-compiled localized messages for DateRangePicker component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import dateRangePickerMessages_en from "./intl/en";
import dateRangePickerMessages_de from "./intl/de";
import dateRangePickerMessages_es from "./intl/es";
import dateRangePickerMessages_fr from "./intl/fr-FR";
import dateRangePickerMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const dateRangePickerMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(dateRangePickerMessages_en),
  de: normalizeMessages(dateRangePickerMessages_de),
  es: normalizeMessages(dateRangePickerMessages_es),
  "fr-FR": normalizeMessages(dateRangePickerMessages_fr),
  "pt-BR": normalizeMessages(dateRangePickerMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for DateRangePicker component
 */
export type DateRangePickerMessageKey =
  | "clearInput"
  | "clearSelection"
  | "endTime"
  | "endTimeHour"
  | "endTimeHourMinute"
  | "endTimeHourMinuteSecond"
  | "endTimeLabel"
  | "openCalendar"
  | "startTime"
  | "startTimeHour"
  | "startTimeHourMinute"
  | "startTimeHourMinuteSecond"
  | "startTimeLabel";
